export interface FeeFieldConfig {
  id: string;
  title: string;
  feeType?: string; // API response field type
  estimatedKey?: string;
  actualKey?: string;
  readyKey?: string;
  isCommentField?: boolean;
}

export const feeFieldsConfig: FeeFieldConfig[] = [
  {
    id: "filling",
    title: "Filling Fee",
    feeType: "Filing Fee",
    estimatedKey: "estimatedFillingFee",
    actualKey: "actualFillingFee",
    readyKey: "readyFilling",
  },
  {
    id: "biometric",
    title: "Biometric Fee",
    feeType: "Biomet Fee",
    estimatedKey: "estimatedBiometricFee",
    actualKey: "actualBiometricFee",
    readyKey: "readyBiometric",
  },
  {
    id: "totalClass",
    title: "Total Class Fee",
    feeType: "Total Fee",
    estimatedKey: "estimatedTotalClassFee",
    actualKey: "actualTotalClassFee",
    readyKey: "readyTotalClass",
  },
  {
    id: "AdjustedFee",
    title: "Adjusted Fee",
    feeType: "Adjust Fee",
    actualKey: "adjustedFee",
    estimatedKey: "",
    readyKey: "adjustedFeeReady",
  },
  {
    id: "EmployeeComments",
    title: "Employee Comments",
    actualKey: "employeeComments",
    estimatedKey: "",
    readyKey: "",
    isCommentField: true,
  },
];

export default feeFieldsConfig;
